/**
 * Button now lives in the shared design system, @atomic/ui-kit, so lmnt and
 * chomps render one identical button and a fix lands in both at once. This is a
 * thin re-export shim: every existing `import { Button } from ".../ui/button"`
 * keeps working unchanged.
 */
export { Button } from "@atomic/ui-kit"
